export default {
  api: 'https://cx-qa-api.curvolabs.com/graphql',
  agGridLicense:
    '',
  supplierPortalBaseUrl: 'https://curvolabstest.appiancloud.com',
  entraTenantId: '3fede61e-4751-4eb7-884f-52a100a89a3a',
  entraClientId: '85449ec4-c3e4-4618-9d50-9b3d3d9c3055',
  entraAuthorityHost: 'https://cbjssostage.ciamlogin.com',
  useHubspot: false,
  useHeap: false,
  launchDarklyClientId:
    '642a8c28bdd73812d6f1d333',
  planeHostUrl: 'https://dev.plane.curvo.cloud',
  broadjumpBaseUrl: 'https://portal-stage.broadjumpllc.com',
}
